module.exports = __webpack_public_path__ + "assets/d3.81f04fdd.svg";